import { createRouter, createWebHistory } from "vue-router";

const VITE_HOST = import.meta.env.VITE_HOST;

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: "/protocol",
			name: "Manipulador de protocolo",
			component: () => import("@/views/ProtocolHandler.vue"),
			meta: {
				title: "Protocol Handler | NEI Market Analytics",
				description: "Redirecting from protocol handler...",
				ogDescription: "Redirecting from protocol handler...",
			},
		},
		{
			path: "/",
			name: "Página Inicial",
			component: () => import("@/views/Home.vue"),
			meta: {
				icon: "House",
				title: "Home | NEI Market Analytics",
				description:
					"Welcome to NEI Market Analytics, your source for comprehensive market analysis.",
				keywords: "market analysis, business insights, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Home | NEI Market Analytics",
				ogDescription:
					"Welcome to NEI Market Analytics, your source for comprehensive market analysis.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/`,
			},
		},
		{
			path: "/login",
			name: "Página de Login",
			component: () => import("@/views/Login/Login.vue"),
			meta: {
				icon: "LogIn",
				title: "Login | NEI Market Analytics",
				description:
					"Welcome to NEI Market Analytics, your source for comprehensive market analysis.",
				keywords: "market analysis, business insights, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Login | NEI Market Analytics",
				ogDescription:
					"Welcome to NEI Market Analytics, your source for comprehensive market analysis.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/login`,
			},
		},
		{
			path: "/login/two-fa",
			name: "Página de Login 2FA",
			component: () => import("@/views/Login/TwoFA/TwoFA.vue"),
			meta: {
				title: "Login 2FA | NEI Market Analytics",
				description:
					"Welcome to NEI Market Analytics, your source for comprehensive market analysis.",
				keywords: "market analysis, business insights, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Login 2FA | NEI Market Analytics",
				ogDescription:
					"Welcome to NEI Market Analytics, your source for comprehensive market analysis.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/login/two-fa`,
			},
		},
		{
			path: "/register",
			name: "Página de Registro",
			component: () => import("@/views/Register.vue"),
			meta: {
				icon: "UserPlus",
				title: "Register | NEI Market Analytics",
				description:
					"Welcome to NEI Market Analytics, your source for comprehensive market analysis.",
				keywords: "market analysis, business insights, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Register | NEI Market Analytics",
				ogDescription:
					"Welcome to NEI Market Analytics, your source for comprehensive market analysis.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/register`,
			},
		},
		{
			path: "/blog",
			name: "Blog",
			component: () => import("@/views/Blog.vue"),
			meta: {
				icon: "Rss",
				title: "Blog | NEI Market Analytics",
				description:
					"Confira vídeos, publicações e novidades do NEI Market Analytics.",
				keywords:
					"blog, vídeos, linkedin, novidades, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Blog | NEI Market Analytics",
				ogDescription:
					"Confira vídeos, publicações e novidades do NEI Market Analytics.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/blog`,
			},
		},
		{
			path: "/about-us",
			name: "Sobre Nós",
			component: () => import("@/views/AboutUs.vue"),
			meta: {
				icon: "Info",
				title: "About Us | NEI Market Analytics",
				description: "Learn more about NEI Market Analytics and our mission.",
				keywords: "about us, NEI Market Analytics, company information",
				robots: "index, follow",
				ogTitle: "About Us | NEI Market Analytics",
				ogDescription: "Learn more about NEI Market Analytics and our mission.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/about-us`,
			},
		},
		{
			path: "/more",
			name: "Mais",
			component: () => import("@/views/More.vue"),
			meta: {
				icon: "Ellipsis",
				title: "More | NEI Market Analytics",
				description:
					"See more details about NEI Market Analytics, your policies, contacts, configurations, and more.",
				keywords:
					"more, policies, cookies policy, privacy policy, contacts, configurations, NEI Market Analytics, company information",
				robots: "index, follow",
				ogTitle: "More | NEI Market Analytics",
				ogDescription:
					"See more details about NEI Market Analytics, your policies, contacts, configurations, and more.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/more`,
			},
		},
		{
			path: "/privacy-policy",
			name: "Política de Privacidade",
			component: () => import("@/views/Policies/PrivacyPolicy.vue"),
			meta: {
				icon: "Lock",
				title: "Privacy Policy | NEI Market Analytics",
				description: "Learn more about our privacy policy.",
				keywords: "privacy policy, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Privacy Policy | NEI Market Analytics",
				ogDescription: "Learn more about our privacy policy.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/privacy-policy`,
			},
		},
		{
			path: "/cookie-policy",
			name: "Política de Cookies",
			component: () => import("@/views/Policies/CookiePolicy.vue"),
			meta: {
				icon: "Cookie",
				title: "Cookie Policy | NEI Market Analytics",
				description: "Learn more about our cookie policy.",
				keywords: "cookie policy, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Cookie Policy | NEI Market Analytics",
				ogDescription: "Learn more about our cookie policy.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/cookie-policy`,
			},
		},
		{
			path: "/terms-of-service",
			name: "Termos de Uso",
			component: () => import("@/views/Policies/TermsOfService.vue"),
			meta: {
				icon: "FileText",
				title: "Terms of Service | NEI Market Analytics",
				description:
					"Termos de uso da plataforma NEI Market Analytics. Leia as condições de uso dos nossos serviços educacionais.",
				keywords: "termos de uso, condições, NEI Market Analytics, política",
				robots: "index, follow",
				ogTitle: "Terms of Service | NEI Market Analytics",
				ogDescription: "Termos de uso da plataforma NEI Market Analytics",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/terms-of-service`,
			},
		},
		{
			path: "/cryptos",
			name: "Criptomoedas",
			component: () => import("@/views/CoinGecko/Cryptos.vue"),
			meta: {
				icon: "Coins",
				title: "Crypto | NEI Market Analytics",
				description: "Explore our comprehensive list of crypto assets.",
				keywords: "crypto, crypto assets, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Crypto | NEI Market Analytics",
				ogDescription: "Explore our comprehensive list of crypto assets.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/cryptos`,
			},
		},
		{
			path: "/nfts",
			name: "NFTs",
			component: () => import("@/views/CoinGecko/Nfts.vue"),
			meta: {
				icon: "Image",
				title: "NFTs | NEI Market Analytics",
				description: "Explore coleções NFT em destaque com dados sobre floor price, volume de negociação e capitalização de mercado. Análise completa de NFTs das principais blockchains.",
				keywords: "nfts, nft brasil, coleções nft, digital collectibles, floor price nft, volume nft, opensea, blur, ethereum nft, polygon nft, NFT Market Analytics",
				robots: "index, follow",
				ogTitle: "NFTs | NEI Market Analytics",
				ogDescription: "Descubra e analise as principais coleções NFT com dados em tempo real de floor price, volume de vendas e estatísticas de mercado.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/nfts`,
			},
		},
		{
			path: "/stocks",
			name: "Ações",
			component: () => import("@/views/BrapiDev/Stocks.vue"),
			meta: {
				icon: "BriefcaseBusiness",
				title: "Stocks | NEI Market Analytics",
				description: "Explore our comprehensive list of stocks.",
				keywords: "stocks, stock assets, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Stocks | NEI Market Analytics",
				ogDescription: "Explore our comprehensive list of stocks.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/stocks`,
			},
		},
		{
			path: "/news",
			name: "Notícias",
			component: () => import("@/views/Finnhub/News.vue"),
			meta: {
				icon: "Newspaper",
				title: "News | NEI Market Analytics",
				description: "Explore our comprehensive list of News.",
				keywords: "news, news assets, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "News | NEI Market Analytics",
				ogDescription: "Explore our comprehensive list of news.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/news`,
			},
		},
		{
			path: "/cryptos/:crypto",
			name: "Cripto Detalhada",
			component: () => import("@/views/CoinGecko/CryptoDetail/CryptoDetail.vue"),
			meta: {
				description: "Explore our comprehensive crypto.",
				keywords: "crypto, crypto assets, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Crypto | NEI Market Analytics",
				ogDescription: "Explore our comprehensive crypto.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/cryptos/:crypto`,
			},
			props: (route) => ({ key: route.params.crypto }),
		},
		{
			path: "/nfts/:nft",
			name: "NFT Detalhada",
			component: () => import("@/views/CoinGecko/NftDetail/NftDetail.vue"),
			meta: {
				description: "Análise detalhada de coleção NFT com floor price, volume 24h, vendas diárias, endereços únicos e estatísticas de mercado completas.",
				keywords: "nft analysis, floor price, nft volume, nft sales, unique holders, ath nft, digital collectibles market, blockchain nft, NFT Market Analytics",
				robots: "index, follow",
				ogTitle: "NFT | NEI Market Analytics",
				ogDescription: "Estatísticas completas de coleção NFT incluindo floor price, volume de negociação, vendas diárias e análise de mercado em tempo real.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/nfts/:nft`,
			},
			props: (route) => ({ key: route.params.nft }),
		},
		{
			path: "/stocks/:ticker",
			name: "Ação Detalhada",
			component: () => import("@/views/BrapiDev/StockDetail/StockDetail.vue"),
			meta: {
				description: "Explore our comprehensive list of stocks.",
				keywords: "stocks, stock assets, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Stocks | NEI Market Analytics",
				ogDescription: "Explore our comprehensive list of stocks.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/stocks/:ticker`,
			},
			props: (route) => ({ key: route.params.ticker }),
		},
		{
			path: "/currency-converter",
			name: "Conversor de Moedas",
			component: () => import("@/views/Tools/CurrencyConverter.vue"),
			meta: {
				icon: "Repeat",
				title: "Currency Converter | NEI Market Analytics",
				description: "Currency Converter",
				keywords: "Currency Converter, currency, converter, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Currency Converter | NEI Market Analytics",
				ogDescription: "Currency Converter",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/tools/currency-converter`,
			},
		},
		{
			path: "/github-redirect",
			name: "Redirecionador do GitHub",
			component: () => import("@/views/GithubRedirect.vue"),
			meta: {
				title: "Github Redirect | NEI Market Analytics",
				description: "Github Redirect",
				keywords: "Github Redirect, github, redirect, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Github Redirect | NEI Market Analytics",
				ogDescription: "Github Redirect",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/github-redirect`,
			},
		},
		{
			path: "/user",
			name: "Conta",
			component: () => import("@/views/User/User.vue"),
			meta: {
				icon: "CircleUser",
				title: "Account | NEI Market Analytics",
				description: "Account",
				keywords: "account, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Account | NEI Market Analytics",
				ogDescription: "Account",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/user`,
			},
		},
		{
			path: "/user/favorite-items",
			name: "Itens Favoritos",
			component: () => import("@/views/User/FavoriteItems/FavoriteItems.vue"),
			meta: {
				icon: "Star",
				title: "Favorite Items | NEI Market Analytics",
				description: "View your favorite cryptos or stocks.",
				keywords:
					"favorites, cryptos, stocks, favorite items, items, item, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Favorite Items | NEI Market Analytics",
				ogDescription: "View your favorite cryptos or stocks.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/user/favorites`,
			},
			props: (route) => ({ type: route.query.type }),
		},
		{
			path: "/user/register-tables",
			name: "Tabelas de Registro",
			component: () => import("@/views/User/RegisterTable/RegisterTables.vue"),
			meta: {
				icon: "Table",
				title: "Register Tables | NEI Market Analytics",
				description: "Manage your favorite tables.",
				keywords: "register tables, register, tables, table, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Register Tables | NEI Market Analytics",
				ogDescription: "Manage your favorite tables.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/user/register-tables`,
			},
		},
		{
			path: "/user/register-tables/:id",
			name: "Tabela de Registro",
			component: () => import("@/views/User/RegisterTable/RegisterTable.vue"),
			meta: {
				title: "Register Tables | NEI Market Analytics",
				description: "Manage your favorite tables.",
				keywords: "register table, register, tables, table, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Register Table | NEI Market Analytics",
				ogDescription: "Manage your favorite table.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/user/register-tables/:id`,
			},
			props: (route) => ({ key: route.params.id }),
		},
		{
			path: "/feedback",
			name: "Feedback",
			component: () => import("@/views/Feedback.vue"),
			meta: {
				icon: "Sticker",
				title: "Feedback | NEI Market Analytics",
				description: "Feedback",
				keywords: "Feedback, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Feedback | NEI Market Analytics",
				ogDescription: "Feedback",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/feedback`,
			},
		},
		{
			path: "/release-notes",
			name: "Notas de Lançamento",
			component: () => import("@/views/ReleaseNotes/ReleaseNotesView.vue"),
			meta: {
				icon: "NotepadText",
				title: "Release Notes | NEI Market Analytics",
				description: "Release Notes",
				keywords: "Release Notes, release, notes, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Release Notes | NEI Market Analytics",
				ogDescription: "Release Notes",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/release-notes`,
			},
		},
		{
			path: "/release-notes/:id",
			name: "Nota de Lançamento",
			component: () => import("@/views/ReleaseNotes/ReleaseNoteView.vue"),
			meta: {
				title: "Release Note | NEI Market Analytics",
				description: "Release Note",
				keywords: "Release Note, release, note, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Release Note | NEI Market Analytics",
				ogDescription: "Release Note",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/release-notes/:id`,
			},
			props: (route) => ({ key: route.params.id }),
		},
		{
			path: "/calendar",
			name: "Calendário",
			component: () => import("@/views/Calendar.vue"),
			meta: {
				icon: "Calendar",
				title: "Calendar | NEI Market Analytics",
				description: "View your schedule and upcoming events.",
				keywords: "calendar, schedule, events, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Calendar | NEI Market Analytics",
				ogDescription: "View your schedule and upcoming events.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/calendar`,
			},
		},
		{
			path: "/heatmaps",
			name: "Mapas de Calor",
			component: () => import("@/views/Heatmaps.vue"),
			meta: {
				icon: "Flame",
				title: "Heatmaps | NEI Market Analytics",
				description:
					"Visualize market performance with interactive heatmaps for stocks and cryptocurrencies. Real-time data from TradingView.",
				keywords:
					"market heatmap, stock heatmap, crypto heatmap, market visualization, trading analysis, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Heatmaps | NEI Market Analytics",
				ogDescription:
					"Visualize market performance with interactive heatmaps for stocks and cryptocurrencies. Real-time data from TradingView.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/heatmaps`,
			},
		},
		{
			path: "/education",
			name: "Academia NEI",
			component: () => import("@/views/Education/Education.vue"),
			meta: {
				icon: "GraduationCap",
				title: "NEI Academy | NEI Market Analytics",
				description:
					"Aprenda sobre investimentos, análise de mercado e estratégias de trading com nossos guias completos e artigos educacionais.",
				keywords:
					"educação financeira, aprender investimentos, análise técnica, mercado financeiro, trading, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "NEI Academy | NEI Market Analytics",
				ogDescription:
					"Aprenda sobre investimentos, análise de mercado e estratégias de trading com nossos guias completos e artigos educacionais.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/education`,
			},
		},
		{
			path: "/education/articles",
			name: "Artigos Educacionais",
			component: () => import("@/views/Education/Articles/Articles.vue"),
			meta: {
				icon: "BookOpen",
				title: "Educational Articles | NEI Market Analytics",
				description:
					"Artigos completos sobre investimentos, análise de mercado, estratégias e metodologias para traders e investidores.",
				keywords:
					"artigos investimentos, educação financeira, análise de mercado, estratégias trading, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Educational Articles | NEI Market Analytics",
				ogDescription:
					"Artigos completos sobre investimentos, análise de mercado, estratégias e metodologias para traders e investidores.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/education/articles`,
			},
		},
		{
			path: "/education/articles/:slug",
			name: "Artigo Educacional",
			component: () => import("@/views/Education/Articles/Article.vue"),
			meta: {
				title: "Article | NEI Market Analytics",
				description: "Artigo educacional sobre investimentos e análise de mercado.",
				keywords:
					"artigo investimentos, educação financeira, análise de mercado, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Article | NEI Market Analytics",
				ogDescription: "Artigo educacional sobre investimentos e análise de mercado.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/education/articles/:slug`,
			},
			props: (route) => ({ slug: route.params.slug }),
		},
		{
			path: "/education/guides",
			name: "Guias Práticos",
			component: () => import("@/views/Education/Guides/Guides.vue"),
			meta: {
				icon: "Map",
				title: "Guides | NEI Market Analytics",
				description:
					"Guias passo-a-passo para usar nossas ferramentas de análise de mercado e maximizar seus resultados.",
				keywords:
					"guias práticos, como usar, ferramentas análise, tutorial investimentos, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Guides | NEI Market Analytics",
				ogDescription:
					"Guias passo-a-passo para usar nossas ferramentas de análise de mercado e maximizar seus resultados.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/education/guides`,
			},
		},
		{
			path: "/education/guides/:slug",
			name: "Guia Prático",
			component: () => import("@/views/Education/Guides/Guide.vue"),
			meta: {
				title: "Guide | NEI Market Analytics",
				description: "Guia prático para usar as ferramentas do NEI Market Analytics.",
				keywords: "guia prático, tutorial, como usar, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Guide | NEI Market Analytics",
				ogDescription: "Guia prático para usar as ferramentas do NEI Market Analytics.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/education/guides/:slug`,
			},
			props: (route) => ({ slug: route.params.slug }),
		},
		{
			path: "/education/glossary",
			name: "Glossário Financeiro",
			component: () => import("@/views/Education/Glossary/Glossary.vue"),
			meta: {
				icon: "BookMarked",
				title: "Financial Glossary | NEI Market Analytics",
				description:
					"Dicionário completo de termos financeiros, econômicos e de investimentos para traders e investidores.",
				keywords:
					"glossário financeiro, termos investimentos, dicionário mercado financeiro, NEI Market Analytics",
				robots: "index, follow",
				ogTitle: "Financial Glossary | NEI Market Analytics",
				ogDescription:
					"Dicionário completo de termos financeiros, econômicos e de investimentos para traders e investidores.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/education/glossary`,
			},
		},
		{
			path: "/education/methodology",
			name: "Metodologia dos Dados",
			component: () => import("@/views/Methodology.vue"),
			meta: {
				icon: "Settings",
				title: "Data Methodology | NEI Market Analytics",
				description:
					"Entenda como coletamos, processamos e apresentamos dados financeiros confiáveis para análise de mercado.",
				keywords:
					"metodologia dados, coleta dados financeiros, precisão dados mercado, fontes dados NEI Analytics",
				robots: "index, follow",
				ogTitle: "Data Methodology | NEI Market Analytics",
				ogDescription:
					"Entenda como coletamos, processamos e apresentamos dados financeiros confiáveis para análise de mercado.",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/education/methodology`,
			},
		},
		{
			path: "/admin",
			name: "Admin Login",
			component: () => import("@/views/System/AdminLogin.vue"),
			meta: {
				title: "Admin | NEI Market Analytics",
				description: "Admin access panel",
				keywords: "admin, login, NEI Market Analytics",
				robots: "noindex, nofollow",
				ogTitle: "Admin | NEI Market Analytics",
				ogDescription: "Admin access panel",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/admin`,
			},
		},
		{
			path: "/wp-admin",
			name: "WP Admin",
			component: () => import("@/views/System/WpLogin.vue"),
			meta: {
				title: "Log In | NEI Market Analytics",
				description: "Log in to your account",
				keywords: "login, wordpress, NEI Market Analytics",
				robots: "noindex, nofollow",
				ogTitle: "Log In | NEI Market Analytics",
				ogDescription: "Log in to your account",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/wp-admin`,
			},
		},
		{
			path: "/api/console",
			name: "API Console",
			component: () => import("@/views/System/ApiConsole.vue"),
			meta: {
				title: "API Console | NEI Market Analytics",
				description: "Developer API Console",
				keywords: "api, console, developer, NEI Market Analytics",
				robots: "noindex, nofollow",
				ogTitle: "API Console | NEI Market Analytics",
				ogDescription: "Developer API Console",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/api/console`,
			},
		},
		{
			path: "/:pathMatch(.*)*",
			name: "Não Encontrado",
			component: () => import("@/components/views/Exceptions/NotFound.vue"),
			meta: {
				title: "404 | NEI Market Analytics",
				description: "Page not found",
				keywords: "404, page not found, NEI Market Analytics",
				robots: "noindex, nofollow",
				ogTitle: "404 | NEI Market Analytics",
				ogDescription: "Page not found",
				ogImage: "/logo.svg",
				ogUrl: `${VITE_HOST}/`,
			},
		},
	],
});

router.beforeEach((to, _from, next) => {
	document.title = (to.meta.title as string) || "NEI Market Analytics";

	const metaTags = [
		{ name: "description", content: to.meta.description as string },
		{ name: "keywords", content: to.meta.keywords as string },
		{ name: "robots", content: to.meta.robots as string },
		{ property: "og:title", content: to.meta.ogTitle as string },
		{
			property: "og:description",
			content: to.meta.ogDescription as string,
		},
		{ property: "og:image", content: to.meta.ogImage as string },
		{ property: "og:url", content: to.meta.ogUrl as string },
	];

	for (const tag of metaTags) {
		const key = tag.name ? "name" : "property";
		const value = tag.name || tag.property;
		if (!value) continue;

		let element = document.querySelector(`meta[ ${key} = "${value}" ]`);
		if (element) {
			element.setAttribute("content", tag.content);
		} else {
			element = document.createElement("meta");
			element.setAttribute(key, value);
			element.setAttribute("content", tag.content);
			document.head.appendChild(element);
		}
	}

	next();
});

export default router;
